import { MyCommonService } from "./my-common.service";
import { HttpClient } from "@angular/common/http";
import {Injectable, Inject, PLATFORM_ID} from "@angular/core";
import { environment } from "../../../environments/environment";
import { map, catchError } from "rxjs/operators";
import { Subject } from "rxjs";
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: "root"
})
export class HomeService {

  profileDentistData: any;
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private myCommonService: MyCommonService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage = window.localStorage;
    }
  }
  homeSettings(data){
    return this.http.post(`${environment.apiURL}/service/homesetting/home-settings`, data);
  }

  homeSocial(link_id) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/homesetting/social-media-link`,
      { link_id: link_id }
    );
  }

  load_user() {
    var name = "default(error)";
    var data = {
      auth_token: this.localStorage?.getItem("user_auth_token")
    };

    return this.http.post(`${environment.apiURL}/getUserInfo`, data);
  }

  allCMS(data){
    return this.http.post(`${environment.apiURL}/service/cms/all-cms`, data);
  }

  submitForm(data){
    return this.http.post(`${environment.apiURL}/service/cms/submit-contact`, data);
  }
  subscribePlan(data){
    return this.http.post(`${environment.apiURL}/subscribe-plan`, data);
  }
  getDentistDataForHomePage(data){
    return this.http.post(`${environment.apiURL}/get-all-dentist-info`, data);
  }
  getOnlineStatusOfDentist(){
    return this.http.get(`${environment.apiURL}/get-admin-last-activity-date`);
  }
  verifyDentist(data){
    return this.http.post(`${environment.apiURL}/verify-dentist`, data);
  }
  markMovefromWelcome(data){
    return this.http.post(`${environment.apiURL}/markAs-welcome`, data);
  }
  isDentistAccountUnderReview(data){
    return this.http.post(`${environment.apiURL}/desntist-underreview`, data);
  }
}
